import UserDashboardPageState from "js/stores/pages/UserDashboardPageState";
import React from "react";
import Activity from "./Activity";
import PubSub from "pubsub-js";
import { useState } from "react";
import * as clipboard from "clipboard-polyfill/text";

const ActivitiesList = ({ stats }) => {

    const [copiedItem, setCopiedItem] = useState(null);

    const copyText = ({item,text}) => {
        PubSub.publish('popup-text', 'Link copied!');
        clipboard
            .writeText(text)
            .then(() => { 
                setCopiedItem(item);
             })
            .catch(() => { });
    };

    return (
        <div className="dashboard-activity">
            <table><tbody>
                {stats.activity_today && (
                    <>{stats.activity_today.map((activity, index) => (
                        <Activity activity={activity} key={`activity-${index}`} onCopy={copyText} copied={activity.item_alias === copiedItem} />
                    ))}</>
                )}
                {stats.activity_older && (
                    <>{stats.activity_older.map((activity, index) => (
                        <Activity activity={activity} key={`activity-${index}`} onCopy={copyText} copied={activity.item_alias === copiedItem} />
                    ))}</>
                )}
            </tbody></table>
        </div>
    )
};

export default ActivitiesList;